import React, { PureComponent } from 'react';
// import { Link } from 'react-router-dom';
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  FormFeedback,
  Button,
  ButtonToolbar,
  Popover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';
import EyeIcon from 'mdi-react/EyeIcon';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { axios } from 'ApiClient';
import WVValidator from '../../../shared/helpers/WVValidator';
import withNotice from '../../App/store/with-notice';
import { initializeSession } from '../../App/store/store';

class AccountSettings extends PureComponent {
  static propTypes = {
    addNotice: PropTypes.func.isRequired,
    brandUser: PropTypes.objectOf(PropTypes.any).isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.state = {
      email: '',
      firstName: '',
      lastName: '',
      oldPassword: '',
      newPassword: '',
      repeatPassword: '',
      showOldPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
      errors: {},
      isPopoverOpen: false,
      loading: {
        submit: false,
      },
    };
  }

  componentDidMount() {
    document.title = 'IL Brand Portal: Account Settings';

    const { brandUser } = this.props;

    // eslint-disable-next-line
    this.setState({
      email: brandUser.email,
      firstName: brandUser.firstName,
      lastName: brandUser.lastName,
    });
  }

  // HANDLERS
  onDataChanged = (event) => {
    const { name, value } = event.target;
    const state = {
      ...this.state,
      [name]: value,
    };

    delete state.errors[name]; // clear errors

    this.setState(state);
  }

  onSubmit = () => {
    if (this.state.loading.submit) { return; }
    if (!this.validateErrors()) { return; }

    this.setState({
      loading: {
        submit: true,
      },
    });

    const { dispatch } = this.props;
    const {
      email,
      firstName,
      lastName,
      oldPassword,
      newPassword,
      repeatPassword,
    } = this.state;
    const formData = this.fillFormData({
      email,
      firstName,
      lastName,
      oldPassword,
      newPassword,
      repeatPassword,
    });

    axios({
      method: 'post',
      url: '/api/brand/account-settings',
      data: formData,
    }).then((response) => {
      // console.log('SUCCESS RESPONSE', response);
      if (response.data.success && response.data.brandUser) {
        this.props.addNotice({
          message: 'Your account settings have been updated successfully.',
          type: 'success',
        });

        dispatch(initializeSession(response.data.brandUser));

        this.props.history.push('/');
      } else {
        this.processSubmitError(response.data.error);
      }
    }).catch((error) => {
      this.processSubmitError(error.message);
    });
  }

  onCancel = () => {
    this.props.history.goBack();
  }

  fillFormData = (body) => {
    const data = new FormData();
    Object.keys(body).forEach((key) => {
      data.append(key, body[key]);
    });
    return data;
  };


  togglePopover = () => {
    this.setState({
      isPopoverOpen: !this.state.isPopoverOpen,
    });
  };

  // METHODS
  validateErrors() {
    const errors = {};
    const {
      email,
      firstName,
      lastName,
      oldPassword,
      newPassword,
      repeatPassword,
    } = this.state;

    if (!WVValidator.isEmail(email)) {
      errors.email = 'Please check your email format!';
    }
    if (WVValidator.isEmpty(firstName)) {
      errors.firstName = 'Please provide your first name.';
    }
    if (WVValidator.isEmpty(lastName)) {
      errors.lastName = 'Please provide your last name.';
    }

    if (WVValidator.isEmpty(oldPassword) &&
      WVValidator.isEmpty(newPassword) &&
      WVValidator.isEmpty(repeatPassword)) {
      this.setState({ errors });

      return Object.entries(errors).length === 0;
    }

    if (WVValidator.isEmpty(this.state.oldPassword)) {
      errors.oldPassword = 'Please provide your old password!';
    }
    if (WVValidator.isEmpty(this.state.newPassword)) {
      errors.newPassword = 'Please provide your new password!';
    }
    if (this.state.newPassword.length < 8) {
      errors.newPassword = 'Yor password must consist of at least 8 symbols';
    } else if (!WVValidator.isValidPassword(this.state.newPassword)) {
      // eslint-disable-next-line
      errors.newPassword = 'Your password must consist of at least 1 number, 1 capital letter, 1 lowercase letter and 1 special character ($.,)(!%^*#)';
    }
    if (WVValidator.isEmpty(this.state.repeatPassword)) {
      errors.repeatPassword = 'Please confirm your new password!';
    }
    if (this.state.newPassword !== this.state.repeatPassword) {
      errors.repeatPassword = 'Passwords do not match!';
    }

    this.setState({
      errors,
    });

    return Object.entries(errors).length === 0;
  }

  showPassword = (property) => {
    this.setState({
      [`${property}`]: !this.state[`${property}`],
    });
  }
  showOldPassword = () => {
    this.showPassword('showOldPassword');
  };
  showNewPassword = () => {
    this.showPassword('showNewPassword');
  };
  showRepeatPassword = () => {
    this.showPassword('showRepeatPassword');
  };

  hasError = name => Object.prototype.hasOwnProperty.call(this.state.errors, name);

  processSubmitError(error) {
    this.props.addNotice({
      message: error,
      type: 'error',
    });

    this.setState({
      loading: {
        submit: false,
      },
    });
  }

  render() {
    const { brandUser } = this.props;
    // console.log('LSD LOG brandUser:', brandUser);

    return (
      <Container>
        <Row>
          <Col lg={{ size: 8, offset: 2 }} sm={12}>
            <h3 className="page-title">Account Settings</h3>
          </Col>
        </Row>
        <Row>
          <Col lg={{ size: 8, offset: 2 }} sm={12}>
            <Card>
              <CardBody>
                <div className="card__title">
                  <h5 className="bold-text">{`${brandUser.firstName} ${brandUser.lastName}`}</h5>
                </div>
                {/* INFORMATION */}
                <section>
                  <h4 className="il-color-deep-blue font-weight-bold mt-5">Information</h4>
                  <hr className="mt-3 mb-4" />
                  <FormGroup>
                    <Label for="emailInput">Email</Label>
                    <Input
                      name="email"
                      type="email"
                      bsSize="lg"
                      value={this.state.email}
                      invalid={this.hasError('email')}
                      onChange={this.onDataChanged}
                    />
                    <FormFeedback>{this.state.errors.email}</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label for="firstNameInput">First Name</Label>
                    <Input
                      name="firstName"
                      type="text"
                      bsSize="lg"
                      value={this.state.firstName}
                      invalid={this.hasError('firstName')}
                      onChange={this.onDataChanged}
                    />
                    <FormFeedback>{this.state.errors.firstName}</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label for="lastNameInput">Last Name</Label>
                    <Input
                      name="lastName"
                      type="text"
                      bsSize="lg"
                      value={this.state.lastName}
                      invalid={this.hasError('lastName')}
                      onChange={this.onDataChanged}
                    />
                    <FormFeedback>{this.state.errors.lastName}</FormFeedback>
                  </FormGroup>
                </section>
                {/* PASSWORD */}
                <section>
                  <h4 className="il-color-deep-blue font-weight-bold mt-5">Change Password</h4>
                  <hr className="mt-3 mb-4" />
                  <FormGroup>
                    <Label for="oldPasswordInput">Old Password</Label>
                    <InputGroup size="lg">
                      <Input
                        name="oldPassword"
                        type={this.state.showOldPassword ? 'text' : 'password'}
                        bsSize="lg"
                        invalid={this.hasError('oldPassword')}
                        onChange={this.onDataChanged}
                      />
                      <InputGroupAddon addonType="append">
                        <button
                          className={`form__form-group-button${this.state.showOldPassword ? ' active' : ''}`}
                          onClick={e => this.showOldPassword(e)}
                          data-property-name="showOldPassword"
                        ><EyeIcon />
                        </button>
                      </InputGroupAddon>
                      <FormFeedback>{this.state.errors.oldPassword}</FormFeedback>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <Label for="newPasswordInput">New Password</Label>
                    <InputGroup size="lg">
                      <Input
                        id="newPasswordInput"
                        name="newPassword"
                        type={this.state.showNewPassword ? 'text' : 'password'}
                        bsSize="lg"
                        invalid={this.hasError('newPassword')}
                        onChange={this.onDataChanged}
                      />
                      <Popover
                        id="popover-new-password"
                        placement="left"
                        isOpen={this.state.isPopoverOpen}
                        target="newPasswordInput"
                        trigger="focus"
                        toggle={this.togglePopover}
                      >
                        <PopoverHeader>Password requirements:</PopoverHeader>
                        <PopoverBody>
                          <p>
                            at least 1 Upper Case letter<br />
                            at least 1 Lower Case letter<br />
                            at least 1 number<br />
                            at least 1 special character ($.,)(!%^*#)<br />
                            at least 8 characters in length<br />
                            New Password and Confirm Password should match
                          </p>
                        </PopoverBody>
                      </Popover>
                      <InputGroupAddon addonType="append">
                        <button
                          className={`form__form-group-button${this.state.showNewPassword ? ' active' : ''}`}
                          onClick={e => this.showNewPassword(e)}
                        ><EyeIcon />
                        </button>
                      </InputGroupAddon>
                      <FormFeedback>{this.state.errors.newPassword}</FormFeedback>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <Label for="passwordInput">Repeat New Password</Label>
                    <InputGroup size="lg">
                      <Input
                        name="repeatPassword"
                        type={this.state.showRepeatPassword ? 'text' : 'password'}
                        bsSize="lg"
                        invalid={this.hasError('repeatPassword')}
                        onChange={this.onDataChanged}
                      />
                      <InputGroupAddon addonType="append">
                        <button
                          className={`form__form-group-button${this.state.showRepeatPassword ? ' active' : ''}`}
                          onClick={e => this.showRepeatPassword(e)}
                        ><EyeIcon />
                        </button>
                      </InputGroupAddon>
                      <FormFeedback>{this.state.errors.repeatPassword}</FormFeedback>
                    </InputGroup>
                  </FormGroup>
                </section>
                {/* BUTTONS */}
                <ButtonToolbar className="form__button-toolbar mt-5">
                  <Button
                    className="px-5 btn btn-sm"
                    type="button"
                    color="primary"
                    onClick={this.onSubmit}
                  >
                    {
                      this.state.loading.submit &&
                      <span><div className="spinner-border text-light spinner-border-sm" /> </span>
                    }
                    <span>Save</span>
                  </Button>
                  <Button
                    className="px-5 btn btn-sm"
                    type="button"
                    onClick={this.onCancel}
                    disabled={this.state.loading.submit}
                  >
                    Cancel
                  </Button>
                </ButtonToolbar>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  rtl: state.rtl,
  brandUser: state.session,
});

export default withNotice(connect(mapStateToProps)(AccountSettings));
